window.GoogleSync = {

	translations: {
		prefs				: Loc.g("Préférences Google Sync"),
		close				: Loc.g("Fermer"),
		save				: Loc.g("Enregistrer"),
		calendarSynchronize	: Loc.g("Le temps de chargement peut être important car les agendas se synchronisent. <br/>Veuillez patienter, ce message disparaitra automatiquement à la fin de la synchronisation"),
		titleSynchroKo		: Loc.g("Un problème est survenu"),
		messageSynchroKo	: Loc.g("Un problème est survenu lors de la synchronisation. Veuillez réessayer plus tard"),
		synchroContact		: Loc.g("Le temps de synchronisation des contacts peut être important en fonction du nombre de contacts à synchroniser. <br/>Veuillez patienter, ce message disparaitra automatiquement à la fin de la synchronisation"),
		reconnect			: Loc.g("Reconnexion Google Sync"),
		reinit				: Loc.g("Réinitialiser le module Google Sync"),
		confirmReinit		: Loc.g("Etes-vous sûr de vouloir réinitialiser le module ?"),
		titleConnect		: Loc.g("Connexion à Google"),
		fetchCalendarKo		: Loc.g("Un problème est survenu, vos calendriers n'ont pas été récupérés. Veuillez réessayer plus tard."),
		synchronisation		: Loc.g("Synchronisation")
	},

	settings: {
		route : "googlesync_prefs",
	},

	loadPrefs : function(load){
		var self = this;
		var options = {
			title	: self.translations.prefs,
			buttons	: [
				{
					text  : self.translations.close,
					'class'	: 'btn btn-default',
					click : function(){
						MyWindow.close();
					}
				},
				{
					text	: self.translations.save,
					'class'	: 'btn btn-primary',
					click	: function(){
						$('#gsyncPrefsForm').closest('form').submit();
					}
				}
			],
			width: 500,
			callback : function(){
				GoogleSync.preparePrefsForm();
			}
		};

        if (load) {
        	options.waitMsg = self.translations.calendarSynchronize;
        }

		var fileOpt = {
			action : "list"
		};
		MyWindow.load(self.settings.route, fileOpt, options);
	},

	preparePrefsForm : function(){
		var options = {
			success:function(data){
				GoogleSync.recordCallback(data);
				MyWindow.close();
			},
			dataType:"json"
		};
		MyForm.prepare("gsyncPrefsForm", "googlesync_prefs&action=record", options, true);
		MyFacture.customForm();
	},

	recordCallback : function(data){
		MyWindow.awake();
	},

	connect : function(refreshToken) {
		var self = this;

		MyFacture.post("googlesync_prefs&action=getToken&refreshToken="+(refreshToken != undefined ? refreshToken : 0), null,  function(data) {
			if(data != null) {
				var options = {
					resizable	: false,
					noclose		: true,
					title		: self.translations.titleConnect,
					buttons		: [
						{
							text : Loc.g("Annuler"),
							click: function(){
								MyFacture.post("googlesync_prefs&action=disconnect", null, null, "json");
								$(this).dialog("close");
							}
						},
						{
							text : Loc.g("Valider"),
							click: function(){
								window.location = data.authUrl;
							}
						}
					]
				};
				MyWindow.alert(Loc.g("Vous allez être redirigé vers la page d'authentification de Google.")+"<br/><br /><div class=\"alert alert-warning\">"+Loc.g("Afin de profiter pleinement de la synchronisation Google avec Sellsy, vous devez cocher toutes les autorisations présentes sur l'étape suivante.</div>"), options);
			}
		}, "json");

		$(document).keyup(function(e) {
			if (e.keyCode == 27) {
				MyFacture.post("googlesync_prefs&action=disconnect", null, null, "json");
			}
		});
	},

	disconnect : function() {
		MyFacture.post("googlesync_prefs&action=disconnect", null, function(data) {
			GoogleSync.loadPrefs();
		}, "json");
	},

	resetTokens : function(){
		var self = this;
		var options = {
			title	: self.translations.reconnect,
			buttons	: [],
			width: 500,
			callback : function(data){}
		};

		var fileOpt = {action:"reset"};
		MyWindow.load(self.settings.route, fileOpt, options);
	},

	loadDeleteForm : function() {
		var self = this;
		var options = {
			title	: Loc.g("Gestion des suppressions Google/Sellsy"),
			buttons	: [
				{
					text : Loc.g("Annuler"),
					click: function(){
						$(this).dialog("close");
					}
				},
				{
					text : Loc.g("Enregistrer"),
					click: function(){
						$("#googleDeleteForm").submit();
					}
				}
			],
			width: 1000,
			callback : function(data){
				GoogleSync.prepareDeleteForm();
			}
		};

		var fileOpt = {
			action	:	"deleteEventForm"
		};
		MyWindow.load(self.settings.route, fileOpt, options);
	},
	prepareDeleteForm: function() {
		var self = this;

		var formId = "googleDeleteForm";
		var options = {
			data : {
				action : 'deleteEventRecord'
			},
			success: function(data){
				Utils.reload();
			},
			dataType:"json"
		};

	 	MyForm.prepare(formId, self.settings.route, options, true);

		$('input[name=default]').on('click', function() {
			$('input[value=' + $(this).val() + ']').each(function() {
				$(this).prop('checked', true);
			});
		});
	},

	confirmResetAccount: function() {
		var self = this;
		var options = {
			type: "warning",
			resizable	: false,
			noclose		: true,
			title		: self.translations.reinit,
			buttons		: [
				{
					text : Loc.g("Oui"),
					click: function(){
						GoogleSync.resetAccount();
					}
				},
				{
					text : Loc.g("Non"),
					click: function(){
						$(this).dialog("close");
					}
				}
			]
		};
		MyWindow.alert(self.translations.confirmReinit, options);
	},

	resetAccount: function() {
		$('#buttonResetGoogleSync').css('pointer-events', 'none').css('cursor', 'default');
		$('#loader_resetGoogleSync').css('display', 'inline');
		MyFacture.post('googlesync_prefs', {action : 'resetAccount'}, function(){
			$('#loader_resetGoogleSync').css('display', 'none');
			Utils.relocate('?_f=store');
		});
	},

	forceSynchroContact : function() {
		var self = this;

		MyWindow.wait(undefined, self.translations.synchroContact);

		MyFacture.post(self.settings.route,
			{
				action	: 'csync',
				force	: 1
			}, function(data) {
				Push.success(data.message, self.translations.synchronisation);
				MyWindow.awake();
				MyWindow.close();
			},
			'json'
		);
	},

	checkDisplayAgenda : function () {
		if($('input[name=gprefs_syncagenda]').is(':checked')){
			$("#fieldsetAgenda").show();
		} else {
			$("#fieldsetAgenda").hide();
		}
	},

	checkDisplayContact : function () {
		if($('input[name=gprefs_synccontacts]').is(':checked')){
			$("#fieldsetContact").show();
		} else {
			$("#fieldsetContact").hide();
		}
	},

	migrateNow : function (origin) {
		var self   = this;
        var origin = (origin != undefined) ? origin : 'agenda';

		MyWindow.getLoader();

		MyFacture.post(self.settings.route, {
			action	: 'prepareMigrate'
		}, function(data){
			if(origin === "agenda") {
				$("#layout-googlesync").html(data);
			}else {
				$("#content_agenda").html(data);
			}
			GoogleSync.prepareMigrate(origin);
		});
	},

	prepareMigrate : function(origin) {
		var self = this;

		MyFacture.post(self.settings.route, {
			action	: 'loadCalendar'
		}, function(data){
			if(data.result === 'ok'){
				GoogleSync.prepareSync(origin);
			} else {
				MyWindow.alert(self.translations.fetchCalendarKo, {
					type: 'info'
				});
				Utils.relocate("?_f=agenda");
			}
		},'json');
	},

	prepareSync : function(origin) {
		var self   = this;
        var origin = (origin != undefined) ? origin : 'agenda';

		MyFacture.post(self.settings.route, {
			action	: 'prepareSync',
			origin	: origin
		}, function(data){
			if(origin === "agenda") {
				$("#layout-googlesync").html(data);
			}else {
				$("#content_agenda").html(data);
			}
		});
	},

	migrate : function(origin) {
		var self   = this;
		var origin = (origin != undefined) ? origin : 'agenda';
		MyFacture.startWait();

		MyFacture.post(self.settings.route,
			{
				action		: 'synchronizeEventToGoogle',
				nextEvent	: $('#nextEvent').is(':checked'),
				pastEvent	: $('#pastEvent').is(':checked'),
				calendarId	: $('#aevent_calendar').val()
			},
			function(data){
				Push.success(data.message);
				if(origin === "agenda") {
					Utils.relocate("/?_f=agenda");
				} else {
					Utils.reload();
				}
			},
			"json"
		);
	},

	migrateAppLater : function () {
		var self = this;

		MyFacture.post(self.settings.route,
			{
				action		: 'migrateAppLater',
			},
			function(){
				Utils.relocate('?_f=agenda');
			},
			'json'
		);
	}
};
